import React from 'react';
import { useParams } from 'react-router-dom';
import ListPage from '@components/common/layout/ListPage';
import PageWrapper from '@components/common/layout/PageWrapper';
import { DEFAULT_FORMAT, DEFAULT_TABLE_ITEM_SIZE } from '@constants';
import apiConfig from '@constants/apiConfig';
import { orderKindOptions } from '@constants/masterData';
import useListModal from '@hooks/useListModal';
import useRestaurant from '@hooks/useRestaurant';
import useTranslate from '@hooks/useTranslate';
import { BaseTable } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { calcCoefficient, convertUtcToLocalTime, formatMoney } from '@utils';

const VoucherRedemptionListPage = () => {
    const translate = useTranslate();
    const { restaurantId } = useParams();
    const queryParameters = new URLSearchParams(window.location.search);
    const voucherId = queryParameters.get('voucherId');
    const { currentSettingParse } = useRestaurant();

    const {
        data,
        mixinFuncs,
        queryFilter,
        loading,
        pagination,
    } = useListModal({
        apiConfig: apiConfig.voucherRedemption,
        options: {
            pageSize: DEFAULT_TABLE_ITEM_SIZE,
            objectName: translate.formatMessage(commonMessage.voucherRedemption),
        },
        override: (funcs) => {
            funcs.mappingData = (response) => {
                if (response.result === true) {
                    return {
                        data: response.data.content,
                        total: response.data.totalElements,
                    };
                }
            };
            const prepareGetListParams = funcs.prepareGetListParams;
            funcs.prepareGetListParams = (params) => {
                return {
                    ...prepareGetListParams(params),
                    voucherId,
                };
            };
        },
    });

    const columns = [
        {
            title: translate.formatMessage(commonMessage.createdDate),
            dataIndex: 'createdDate',
            width: 180,
            render: (createdDate) => {
                return convertUtcToLocalTime(createdDate, DEFAULT_FORMAT, DEFAULT_FORMAT);
            },
        },
        {
            title: translate.formatMessage(commonMessage.orderStt),
            dataIndex: 'orderStt',
            width: 140,
        },
        {
            title: translate.formatMessage(commonMessage.customerName),
            dataIndex: ['customer', 'userName'],
            render: (text, record) => record.customer?.userName || '-',
        },
        // {
        //     title: translate.formatMessage(commonMessage.deliveryFee),
        //     dataIndex: 'shipMoney',
        //     width: '180px',
        //     align: 'center',
        //     render: (shipMoney) => {
        //         return formatMoney(shipMoney || 0, currentSettingParse);
        //     },
        // },
        {
            title: translate.formatMessage(commonMessage.discountAmount),
            dataIndex: ['voucher', 'discountAmount'],
            width: '180px',
            align: 'center',
            render: (discountAmount) => {
                return formatMoney(discountAmount || 0, currentSettingParse);
            },
        },
        {
            title: translate.formatMessage(commonMessage.totalMoney),
            dataIndex: 'totalMoney',
            width: '180px',
            align: 'center',
            render: (totalMoney, record) => {
                const shipMoney = record.shipMoney || 0;
                const voucherDiscount = record?.voucher?.discountAmount || 0;
                const total = (totalMoney / 100) + shipMoney - voucherDiscount;
                return formatMoney(total, currentSettingParse);
            },
        },
        {
            title: translate.formatMessage(commonMessage.orderType),
            dataIndex: 'kind',
            width: 150,
            render: (kind) => {
                const currentState = orderKindOptions?.find(item => item.value === kind);

                return currentState?.label;
            },
        },
    ];

    const searchFields = [];

    return (
        <PageWrapper
            routes={[
                { breadcrumbName: translate.formatMessage(commonMessage.voucher), path: `/${restaurantId}/voucher` },
                { breadcrumbName: translate.formatMessage(commonMessage.voucherRedemption) },
            ]}
        >
            <ListPage
                searchForm={mixinFuncs.renderSearchForm({ fields: searchFields, initialValues: queryFilter })}
                baseTable={
                    <BaseTable
                        onChange={mixinFuncs.changePagination}
                        columns={columns}
                        dataSource={data}
                        pagination={pagination}
                        loading={loading}
                    />
                }
            />
        </PageWrapper>
    );
};

export default VoucherRedemptionListPage;